import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiCard, EuiSteps } from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import styled from 'styled-components';

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;


class Teaching extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            uploadDisabled: true,
            teaching1Key: ['	Tutor for subjects Math, Chemistry and Physics','	160+ hours invested and 25+ lectures conducted','	Taught 50+ students with 100 percent results ','	50+  assignments evaluated'],
            teaching1Value: ['	Time Management ' ,      '  Patience'            ,      ' Competent Teaching'],
            teaching2Key: ['Taught 5+ Engineering courses to fellow peers  ','	25+ lectures conducted','	160+ hours invested ','	10+ assignments assisted'],
            teaching2Value: ['	Scheduling and Planning '    ,         '  Continuous Learning'   ,               ' Feedbacks Approach '],
            teaching3Key: ['	2 Professors and 1 Undergraduate student  ','	50+ Contact Hours ','	5+ assignments issued ','	5 technical sessions on MDA and Non-linear Analysis Technique'],
            teaching3Value: ['Accountability'  ,               'Collaboration ' ,                ' Assessment skill'],
            mentoring1Key: ['	Finding relevant research articles, identifying research problem','	Recommendations of appropriate tools for analysis','	Philosophical Guidance on respective projects','	Encouraging them to write discussion papers on their research projects to enhance their concepts'],
            mentoring1Value: ['	Team Building  ' ,             ' Exposure to new research ',                 ' Exposure to new technologies'],
            assisting1Key: ['	Provide correct input parameters for prediction of improved SPT N value for sandy soil after stone column has been placed','Prediction of settlement','	Assessment of liquefaction potential after ground improvement',],
            assisting1Value: ['	Exposure to Stone Column application' ,  ' Research Collaboration' ,         ' Exposure to SPT application'],
            assisting2Key: ['	Qualitative comparison with Internal cured concrete with prewetted lightweight fine aggregates','	Prediction models to predict mechanical properties of SAP concrete','	Technical Writing of research articles'],
            assisting2Value: ['	Practice Applied Engineering',                ' Technical Writing',     ' Problem Solving'],
            assisting3Key: ['	600+ Professionals and Practising Engineers','	Presented specification and working of Maturity meter','10+ Students instructed ','	Qualitative difference between in-situ testing and cube testing'],
            assisting3Value: ['	Research awareness' ,               ' Technical Management' ,             ' Problem Solving'],
            assisting4Key: ['	Review of novel method for classifying flexural and punching shear','	Overall quality of manuscript','Assisting in technical review','3 + technical comments'],
            assisting4Value: ['	Critical Appraisal' , '  Technical Review Skills'       ,       ' Exposure to new research area'],
        }
    }

    render() {  
    const teachingList = [
        { title:'Tutoring High School Subjects',
          children: (
            <EuiCard
                textAlign="left"
                title=''
                titleSize="s"
                description={<EuiText textAlign='right' size='xs'>May - August 2016</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching1Key && this.state.teaching1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching1Value && this.state.teaching1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
        },
        { title:'Informally Taught Peers with Undergraduate Courses',
          children: (
            <EuiCard
                textAlign="left"
                title=''
                titleSize="s"
                description={<EuiText textAlign='right' size='xs'>August 2017 – August 2019</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching2Key && this.state.teaching2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching2Value && this.state.teaching2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
        },
        { title:'Instructing Graduate and Under Graduate Students',
          children: (
            <EuiCard
                textAlign="left"
                title=''
                titleSize="s"
                description={<EuiText textAlign='right' size='xs'>April - June 2021</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching3Key && this.state.teaching3Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.teaching3Value && this.state.teaching3Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
        },    
    ]

    const mentoringList = [
      { title:'Mentoring Peers and Juniors on their research projects',
        children: (
          <EuiCard
              textAlign="left"
              title={<EuiText><b>Projects - </b><br/>
              a)	CO2 infused concrete <br/>
              b)	Bachelors Final Year Project of Er. Avinash Varak on Corrosion - Special Acknowledgement</EuiText>}
              titleSize="s"
              description={<EuiText textAlign='right' size='xs'>February 2021 –Present</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.mentoring1Key && this.state.mentoring1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.mentoring1Value && this.state.mentoring1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
      },    
    ]

    const assitingList = [
    { title:'Modified Dimensional Analysis Model for SPT N Improvement  After Stone Column',
      children: (
        <EuiCard
            textAlign="left"
            title={<EuiText><b>Project Objective - </b><br/>
              Prediction of improved SPT (Standard Penetration Test) N value for sandy soil using concept of modified dimensional analysis</EuiText>}
            titleSize="s"
            description={<EuiText textAlign='right' size='xs'>September -November 2020</EuiText>}><EuiText size="s">
            <b>Project Highlights</b>
                    <StyledText><ul className="skills-list">
                    {this.state.assisting1Key && this.state.assisting1Key.map((p, i) => <li key={i}>{p}</li>)}
                    </ul></StyledText>
                    <b>Value Additions </b>
                    <StyledText><ul className="skills-list">
                    {this.state.assisting1Value && this.state.assisting1Value.map((p, i) => <li key={i}>{p}</li>)}
                    </ul></StyledText>
            </EuiText></EuiCard>),
    },
    { title:'Ph.D. Scholar MITSOE ADT University',
      children: (
        <EuiCard
            textAlign="left"
            title={<EuiText><b>Project Objective - </b><br/>
              Assessing the properties and behaviour of Concrete cured with curing action of Super Absorbent Polymer (SAP)</EuiText>}
            titleSize="s"
            description={<EuiText textAlign='right' size='xs'>April – July 2021</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting2Key && this.state.assisting2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting2Value && this.state.assisting2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
    },
    { title:'Techno-Volunteering Constro Exhibition',
      children: (
        <EuiCard
            textAlign="left"
            title={<EuiText><b>Project Objective - </b><br/>
              Marketed and instructed novel Patented Intelligent Concrete Maturity Meter (ICOMM) </EuiText>}
            titleSize="s"
            description={<EuiText textAlign='right' size='xs'>January 2020</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting3Key && this.state.assisting3Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting3Value && this.state.assisting3Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
    },   
    { title:'Technical Paper Review for Prof. HB Dhonde',
      children: (
        <EuiCard
            textAlign="left"
            title={<EuiText><b>Project Objective - </b><br/>
              Review of ACI Structural Journal’s “Punching Shear Strength of Posttensioned UHPC Plates”</EuiText>}
            titleSize="s"
            description={<EuiText textAlign='right' size='xs'>July – August 2021</EuiText>}><EuiText size="s">
                <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting4Key && this.state.assisting4Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.assisting4Value && this.state.assisting4Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                </EuiText></EuiCard>),
    }, 
    ]

    return (
      <>
          <EuiPageTemplate>
              <EuiPageHeader><Header /></EuiPageHeader>
          <EuiFlexGroup gutterSize='xl'>
          <EuiFlexItem>
                  <EuiSpacer />
                  <EuiText><h2><font face='Segoe UI'>Teaching and Instructing</font></h2></EuiText>
                  <EuiSpacer size='m' />
                  <EuiSteps titleSize='xs'steps={teachingList}/>
                  <EuiText><h2><font face='Segoe UI'>Mentoring</font></h2></EuiText>
                  <EuiSpacer size='m' />
                  <EuiSteps titleSize='xs'steps={mentoringList}/>
                  <EuiText><h2><font face='Segoe UI'>Assisting</font></h2></EuiText>
                  <EuiSpacer size='m' />
                  <EuiSteps titleSize='xs'steps={assitingList}/>
                  <div>         
        
      </div>
          </EuiFlexItem>
          </EuiFlexGroup>
      <Footer /></EuiPageTemplate>
      </>
        )
    }
};

export { Teaching }